import { render, staticRenderFns } from "./FormTemplateSelect.vue?vue&type=template&id=66d28252&scoped=true&"
import script from "./FormTemplateSelect.vue?vue&type=script&lang=js&"
export * from "./FormTemplateSelect.vue?vue&type=script&lang=js&"
import style0 from "./FormTemplateSelect.vue?vue&type=style&index=0&id=66d28252&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d28252",
  null
  
)

export default component.exports